import { render, staticRenderFns } from "./StatFilterListComponent.vue?vue&type=template&id=97618580&scoped=true&"
import script from "./StatFilterListComponent.vue?vue&type=script&lang=js&"
export * from "./StatFilterListComponent.vue?vue&type=script&lang=js&"
import style0 from "./StatFilterListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97618580",
  null
  
)

export default component.exports